import React from 'react';
import { Clock, IndianRupee, ShieldCheck } from 'lucide-react';
import { GlassCard, SectionShell } from './LandingPrimitives';

const stats = [
  {
    icon: ShieldCheck,
    value: 'Zero double bookings',
    label: 'since go-live',
    confirmed: true,
  },
  {
    icon: Clock,
    value: '12+ hrs saved',
    label: 'per week on admin work',
    confirmed: false,
  },
  {
    icon: IndianRupee,
    value: '₹50,000+ recovered',
    label: 'monthly from better tracking',
    confirmed: false,
  },
];

const CaseStudySection = () => {
  return (
    <SectionShell
      id="case-study"
      eyebrow="Customer story"
      title="Mavericks Cricket Ground and Academy"
      description="A live operator using Ground Aale to run bookings, staff coordination, and payments from one place."
    >
      <GlassCard className="border border-ga-primary/30">
        <div className="grid gap-6 md:grid-cols-3">
          {stats.map((stat) => {
            const Icon = stat.icon;
            return (
              <div key={stat.value} className="text-center md:text-left">
                <div className="mb-3 inline-flex rounded-lg bg-ga-primary-soft p-2">
                  <Icon className="h-5 w-5 text-ga-primary" />
                </div>
                <p className="text-lg font-semibold text-ga-text-primary">{stat.value}</p>
                <p className="mt-1 text-sm text-ga-text-muted">{stat.label}</p>
              </div>
            );
          })}
        </div>
        <p className="mt-6 border-t border-ga-border-subtle pt-4 text-xs leading-relaxed text-ga-text-subtle">
          Zero double bookings is confirmed from live operations. Time saved and revenue recovered figures are
          illustrative estimates pending final validation with the operator.
        </p>
      </GlassCard>
    </SectionShell>
  );
};

export default CaseStudySection;
